import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { axiosInstance } from '../helpers'

export interface EntrataPropertyPayload {
    entrata_company_id: number
    name?: string
    address?: string
    city?: string
    state?: string
    zip?: string
}

export interface OnboardEntrataPropertiesToCompanyParams {
    company_id: number
    entrata_properties: EntrataPropertyPayload[]
}

export interface OnboardEntrataPropertiesToCompanyResponse {
    message: string
    company_id: number
}

export const useOnboardEntrataPropertiesToCompany = () => {
    const mutation = useMutation({
        mutationFn: async (
            params: OnboardEntrataPropertiesToCompanyParams,
        ): Promise<OnboardEntrataPropertiesToCompanyResponse> => {
            const { data } = await axiosInstance.post(
                'company/entrata-properties-onboard-to-company/',
                params,
            )
            return data
        },
        onSuccess: (data) => {
            toast.success(
                data.message ||
                    `Queued onboarding for ${data.company_id}. You will receive an email upon completion.`,
            )
        },
        onError: (error: any) => {
            const message =
                error?.response?.data?.error ||
                error?.response?.data?.message ||
                'Failed to onboard Entrata properties'
            toast.error(message)
        },
    })

    return {
        onboard: mutation.mutateAsync,
        isLoading: mutation.isLoading,
        error: mutation.error,
        isSuccess: mutation.isSuccess,
        reset: mutation.reset,
    }
}
